/**
 * @generated SignedSource<<99c08f2dc4d38f8f0c1a4aba1b781e54>>
 * @relayHash 070b904544b6a8ced75db8dac4c3d517
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID dc5f5db44de6779116ff76ac1aba29dc5d1d22b275c21ecad834d0e47856b9d8

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type HelpObjectStoreArticleSearchExpandType = "ANCESTORS" | "VIEW_COUNT" | "%future added value";
export type HelpObjectStoreSupportSiteArticleSearchInput = {
  articleIds?: ReadonlyArray<string> | null | undefined;
  expand?: ReadonlyArray<HelpObjectStoreArticleSearchExpandType> | null | undefined;
  orderBy?: string | null | undefined;
  parentId?: AGG$Long | null | undefined;
  query?: string | null | undefined;
  topLevelArticlesOnly?: boolean | null | undefined;
};
export type csmFolderSearchArticlesForSupportSiteQuery$variables = {
  cloudId: string;
  first?: number | null | undefined;
  helpCenterAri: string;
  input?: HelpObjectStoreSupportSiteArticleSearchInput | null | undefined;
};
export type csmFolderSearchArticlesForSupportSiteQuery$data = {
  readonly helpObjectStore_searchArticlesForSupportSite: {
    readonly message?: string;
    readonly " $fragmentSpreads": FragmentRefs<"mainCsmFolderItemsRenderer_data">;
  } | null | undefined;
};
export type csmFolderSearchArticlesForSupportSiteQuery = {
  response: csmFolderSearchArticlesForSupportSiteQuery$data;
  variables: csmFolderSearchArticlesForSupportSiteQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "helpCenterAri"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v4 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  },
  {
    "kind": "Variable",
    "name": "helpCenterAri",
    "variableName": "helpCenterAri"
  },
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v5 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "message"
    }
  ],
  "type": "HelpObjectStoreSearchError"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "name": "csmFolderSearchArticlesForSupportSiteQuery",
    "selections": [
      {
        "args": (v4/*: any*/),
        "kind": "LinkedField",
        "name": "helpObjectStore_searchArticlesForSupportSite",
        "plural": false,
        "selections": [
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "kind": "FragmentSpread",
                "name": "mainCsmFolderItemsRenderer_data"
              }
            ],
            "type": "HelpObjectStoreSupportSiteArticleSearchResultConnection"
          },
          (v5/*: any*/)
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v0/*: any*/),
      (v1/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Operation",
    "name": "csmFolderSearchArticlesForSupportSiteQuery",
    "selections": [
      {
        "args": (v4/*: any*/),
        "kind": "LinkedField",
        "name": "helpObjectStore_searchArticlesForSupportSite",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "__typename"
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "concreteType": "HelpObjectStoreSupportSiteArticleSearchResultEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "HelpObjectStoreSupportSiteArticleSearchResult",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "id"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "title"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "contentType"
                      },
                      {
                        "concreteType": "HelpObjectStoreArticleURLInfo",
                        "kind": "LinkedField",
                        "name": "urlInfo",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "shareUrl"
                          }
                        ]
                      }
                    ]
                  }
                ]
              }
            ],
            "type": "HelpObjectStoreSupportSiteArticleSearchResultConnection"
          },
          (v5/*: any*/)
        ]
      }
    ]
  },
  "params": {
    "id": "dc5f5db44de6779116ff76ac1aba29dc5d1d22b275c21ecad834d0e47856b9d8",
    "metadata": {},
    "name": "csmFolderSearchArticlesForSupportSiteQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "0a1a1faa019d9d2d9ee192a4fe336c34";

export default node;
